<template lang="pug">
  div.SearchListTypes
    SearchRefinementList(:attribute-name="name", operator="or", :sortBy="['name:asc']", listType="buttons").SearchListTypes_items
</template>

<script>

import SearchRefinementList from '@/components/SearchRefinementList'

export default {
  props: ['label', 'name'],
  components: { SearchRefinementList }
}

</script>
